import { use } from "react";
import { ScheduleSessionsContext } from "./context";

export function useScheduleSessionsContext() {
  const ctx = use(ScheduleSessionsContext);
  if (!ctx) {
    throw new Error("ScheduleSessions.* components must be rendered inside <ScheduleSessionsProvider>");
  }
  return ctx;
}
